(function() {
    'use strict';

    function commonController($state, $timeout) {
        console.log($state.get());
        $timeout(function () { console.log($state.current); }, 1000);
    }

    commonController.$inject = ['$state', '$timeout'];

    angular.module('ecap.common').controller('commonController', commonController);
})();